/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import * as React from "react";
import { FunctionComponent } from "react";

import { log, tag } from "missionlog";
// import { ActParaItemOK } from "../../../api/schema/getActsParaResp";
import { IStackTokens, Separator, Stack, StackItem } from "office-ui-fabric-react";
import limaDialogStore from "../../../store/limaDialogStore";
import { observer } from "mobx-react-lite";

log.init({ ActParItem: "ActParItem" });

// export interface ActParItemProps {
//   // actParItem: ActParaItemOK;
// }
//({ logo, message, title }: HistItemProps)

const numericalSpacingStackTokens: IStackTokens = {
  childrenGap: 10,
  padding: 0,
  maxWidth: "95%",
};

// const ActParItem: FunctionComponent<ActParItemProps> = () => {
const ActParItem: FunctionComponent = () => {
  // log.info(tag.ActParItem, "ActParItem: Mounted", actParItem);

  function renderString(str) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    str = str.replace(/(\r\n|\n|\r)/gm, "<br>");
    //str.replace(/(§.{0,1}actParItem.parid.{0,30}?o. s. ř.)/gm, "<b>$1</b>")

    //string = string.replace(actParItem.parid, "<b>" + actParItem.parid + "</b>");
    return { __html: str };
  }

  const RenderSentances = observer((): JSX.Element => {
    log.info(tag.ActParItem, "RenderSentances: update");
    if (
      limaDialogStore.actPar === null ||
      limaDialogStore.actPar.presentText === undefined ||
      limaDialogStore.actPar.presentText === null
    ) {
      return <></>;
    } else {
      return (
        <>
          {/* TODO: IN future whe we have sentaces
          {actParItem.sentences.map((singleSentence, i) => (
            <StackItem key={"sent_" + i}>
              <div dangerouslySetInnerHTML={renderString(singleSentence)} />
            </StackItem>
          ))} */}
          <StackItem key={"text_pres"}>
            <div dangerouslySetInnerHTML={renderString(limaDialogStore.actPar.presentText)} />
          </StackItem>
        </>
      );
    }
  });

  return (
    <>
      <Separator></Separator>
      <Stack tokens={numericalSpacingStackTokens}>
        <RenderSentances />
      </Stack>
    </>
  );
};

export default ActParItem;
